import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

window.d3 = d3;
window.dc = dc;

import Vuetify, {
  VCard,
  VRating,
  VToolbar,
  VContainer,
  VLayout,
  VFlex,
  VIcon
} from 'vuetify/lib';
import 'vuetify/dist/vuetify.min.css';
import '@mdi/font/css/materialdesignicons.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';

Vue.use(Vuetify, {
  icons: {
    iconfont: 'mdi'
  },
  components: {
    VCard,
    VRating,
    VToolbar,
    VContainer,
    VLayout,
    VFlex,
    VIcon
  }
});

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
